import { createApiRequest } from "@/lib/api/createApiService";
import { REPORTING_BOUNDARY_ENDPOINTS } from "./reporting-boundary.endpoints";

export const reportingBoundaryService = {
  getReportingBoundary: async (options = {}) => {
    return createApiRequest({
      url: REPORTING_BOUNDARY_ENDPOINTS.REPORTING_BOUNDARY,
      method: "GET",
      ...options,
    });
  },

  getReportingYearByCompany: async (options = {}) => {
    return createApiRequest({
      url: REPORTING_BOUNDARY_ENDPOINTS.REPORTING_YEARS,
      method: "GET",
      ...options,
    });
  },

  getReportingYearList: async (options = {}) => {
    return createApiRequest({
      url: REPORTING_BOUNDARY_ENDPOINTS.REPORTING_YEARS_LIST,
      method: "GET",
      ...options,
    });
  },

  getReportingYearById: async (reportingYearId, options = {}) => {
    return createApiRequest({
      url: `${REPORTING_BOUNDARY_ENDPOINTS.REPORTING_YEARS}/${reportingYearId}`,
      method: "GET",
      ...options,
    });
  },

  createReportingYear: async (data, options = {}) => {
    return createApiRequest({
      url: REPORTING_BOUNDARY_ENDPOINTS.REPORTING_BOUNDARY,
      method: "POST",
      body: data,
      ...options,
    });
  },

  updateReportingYear: async (reportingYearId, payload, options = {}) => {
    console.log("Payload : ", payload);
    return createApiRequest({
      url: `${REPORTING_BOUNDARY_ENDPOINTS.REPORTING_YEARS}/${reportingYearId}`,
      method: "PUT",
      body: payload,
      ...options,
    });
  },

  updateReportingBoundary: async (data, options = {}) => {
    return createApiRequest({
      url: REPORTING_BOUNDARY_ENDPOINTS.REPORTING_BOUNDARY,
      method: "PUT",
      body: data,
      ...options,
    });
  },

  deleteReportingYear: async (id, options = {}) => {
    return createApiRequest({
      url: REPORTING_BOUNDARY_ENDPOINTS.REPORTING_YEAR_DETAIL(id),
      method: "DELETE",
      ...options,
    });
  },

  getFrameworks: async (options = {}) => {
    return createApiRequest({
      url: REPORTING_BOUNDARY_ENDPOINTS.FRAMEWORKS,
      method: "GET",
      ...options,
    });
  },
};
